import { render, staticRenderFns } from "./BackgroundProperties.vue?vue&type=template&id=8f33c718&scoped=true"
import script from "./BackgroundProperties.vue?vue&type=script&lang=js"
export * from "./BackgroundProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f33c718",
  null
  
)

export default component.exports